import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, createVNode as _createVNode, renderList as _renderList, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b45d891"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "summary-header" }
const _hoisted_2 = { class: "slide nps-summary" }
const _hoisted_3 = { class: "summary-title" }
const _hoisted_4 = { class: "nps-big" }
const _hoisted_5 = { class: "nps-change" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "slide" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-title" }, "Responses", -1))
const _hoisted_9 = { class: "stats" }
const _hoisted_10 = { class: "stat-line" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Total", -1))
const _hoisted_12 = { class: "stat-line" }
const _hoisted_13 = { class: "stat-line" }
const _hoisted_14 = { class: "stat-line" }
const _hoisted_15 = { class: "slide" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-title" }, "Surveys", -1))
const _hoisted_17 = { class: "stats" }
const _hoisted_18 = { class: "stat-line" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Sent", -1))
const _hoisted_20 = { class: "stat-line" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Opened", -1))
const _hoisted_22 = { class: "stat-line" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Responded", -1))
const _hoisted_24 = { class: "stat-line" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Response Rate", -1))
const _hoisted_26 = { class: "slide" }
const _hoisted_27 = { class: "summary-title" }
const _hoisted_28 = { class: "summary-dots" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleSpinner = _resolveComponent("SimpleSpinner")!
  const _component_HistoricGraph = _resolveComponent("HistoricGraph")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "sliderContainer",
      class: "slider responses",
      onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_SimpleSpinner, {
              key: 0,
              size: "small",
              class: "spinner",
              "line-fg-color": "#B338A3"
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.mobileQuestionType), 1),
              _createElementVNode("div", _hoisted_4, _toDisplayString(Number(_ctx.npsSummary?.nps).toFixed(1)), 1),
              _createElementVNode("div", _hoisted_5, [
                _createTextVNode(" Change " + _toDisplayString(Number(_ctx.npsSummary?.change).toFixed(1)) + " ", 1),
                (_ctx.npsChange)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "trend-caret",
                      src: _ctx.npsChangeIcon
                    }, null, 8, _hoisted_6))
                  : _createCommentVNode("", true)
              ])
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_SimpleSpinner, {
              key: 0,
              size: "small",
              class: "spinner",
              "line-fg-color": "#B338A3"
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", null, _toDisplayString(_ctx.npsStatsSummary?.total), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.metricLabel('PROMOTER')), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.npsStatsSummary?.promoter), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.metricLabel('PASSIVE')), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.npsStatsSummary?.passive), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.metricLabel('DETRACTOR')), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.npsStatsSummary?.detractor), 1)
                ])
              ])
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_15, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_SimpleSpinner, {
              key: 0,
              size: "small",
              class: "spinner",
              "line-fg-color": "#B338A3"
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", null, _toDisplayString(_ctx.npsStatsSummary?.sent), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", null, _toDisplayString(_ctx.npsStatsSummary?.opened), 1)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", null, _toDisplayString(_ctx.npsStatsSummary?.responded), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("div", null, _toDisplayString(_ctx.npsStatsSummary?.responseRate) + "%", 1)
                ])
              ])
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.trendGraphLabel), 1),
        _createElementVNode("div", null, [
          _createVNode(_component_HistoricGraph)
        ])
      ])
    ], 544),
    _createElementVNode("div", _hoisted_28, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slideNumber, (dot, dotIdx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: dotIdx,
          class: _normalizeClass(["dot", { active: _ctx.currentSlide === dot - 1 }])
        }, null, 2))
      }), 128))
    ])
  ]))
}